export default "__VITE_ASSET__IMJi4A0w__"